module.exports = __webpack_public_path__ + "static/media/kalpeshkathane.ab4e5a65.jpg";